import { render, staticRenderFns } from "./SpeechTextComponent.vue?vue&type=template&id=22000704&"
import script from "./SpeechTextComponent.vue?vue&type=script&lang=js&"
export * from "./SpeechTextComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports